<template>
    <div class="table-container">
        <table class="table table-striped">
            <thead>
                <tr>
                    <th scope="col">Username</th>
                    <th scope="col">Status</th>
                </tr>
            </thead>
            <tbody>
                <template v-if="!accounts.length">
                    <tr>
                        <td colspan="2">No accounts</td>
                    </tr>
                </template>
                <template v-else>
                    <tr v-for="account in accounts" :key="account.accountId">
                        <td><a :href="route('users.show', account.userIdExternal)">{{ account.username }}</a></td>
                        <td>{{ account.isActive ? 'Active' : 'Inactive' }}</td>
                    </tr>
                </template>
            </tbody>
        </table>
        <loading-overlay :loading="isLoading"></loading-overlay>
    </div>
</template>

<script>
export default {
    props: {
        companyId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
            accounts: [],
        }
    },
    mounted() {
        this.isLoading = true;

        axios.get(route('rft.clients.accounts', { company: this.companyId }))
            .then(({ data }) => this.accounts = data)
            .finally(() => this.isLoading = false);
    },
}
</script>


<style scoped lang="scss">
.table-container {
    max-height: 400px;
    overflow: auto;
    position: relative;

    a {
        color: #0d6efd;
        text-decoration-color: #0d6efd;
    }
}
</style>
